import { useTranslate } from '@client/i18n/hooks';

type UsePricesTextsReturnType = {
  listPrice: string,
  listPriceWithVatNumberText: string,
  listPriceWithoutVat: string,
  userPrice: string,
  userPriceWithoutVat: string,
  privatePrice: string,
}

const usePricesTexts = (taxRate: string): UsePricesTextsReturnType => {
  const t = useTranslate();

  return {
    listPrice: t(
      '(SRP <strong>incl.</strong> VAT)',
      null,
      'Suggested Retail Price with VAT',
    ),
    listPriceWithVatNumberText: t(
      '(SRP <strong>incl.</strong> {taxRate} VAT)',
      {
        taxRate: `${taxRate}%`,
      },
      'Suggested Retail Price with VAT - contains VAT number text',
    ),
    listPriceWithoutVat: t(
      '(SRP <strong>excl.</strong> VAT)',
      null,
      'Suggested Retail Price without VAT',
    ),
    userPrice: t(
      '(PP <strong>incl.</strong> VAT)',
      null,
      'Purchase Price with Vat',
    ),
    userPriceWithoutVat: t(
      '(PP <strong>excl.</strong> {taxRate} VAT)',
      {
        taxRate: `${taxRate}%`,
      },
      'Purchase Price without Vat',
    ),
    privatePrice: t(
      '(<strong>incl.</strong> {taxRate} VAT)',
      {
        taxRate: `${taxRate}%`,
      },
      'Private Price with Vat',
    ),
  };
};

export { usePricesTexts };
export type { UsePricesTextsReturnType };
